import axios from 'axios';
import appConfig from '../config/appConfig';

/**
 * Alta/baja de comunidades para el staff de Keenvil ([COMUNIDAD-AUTOMATIZADA] etapa 2).
 * community-api: /community/admin/communities. La autorizacion la hace el back (lista de cuentas staff);
 * con el flag apagado el endpoint no existe (404) y la pantalla no se muestra.
 */
function client(token) {
  return axios.create({
    baseURL: `${appConfig.getApiBaseUrl()}/community/admin/communities`,
    headers: {
      'X-API-Key': appConfig.apiKey,
      'X-Authorization': token,
      'X-Application-Id': 'CASTLEBLACK',
      'X-Device-OS': 'BROWSER',
      Accept: 'application/json'
    },
    timeout: 20000
  });
}

let infoCache = null;

/**
 * { staff, environment, executable, githubConfigured, operations, protectedCommunities, approvalRequired } o null si no
 * aplica. En prod (approvalRequired) cada solicitud la aprueba otra cuenta staff.
 */
export function getAutomationInfo(token, { force = false } = {}) {
  if (!token) {
    return Promise.resolve(null);
  }
  if (!force && infoCache && infoCache.token === token) {
    return infoCache.promise;
  }
  const promise = client(token)
    .get('/automation')
    .then(response => response.data)
    .catch(() => null);
  infoCache = { token, promise };
  return promise;
}

export function listRequests(token, page = 0, size = 20) {
  return client(token)
    .get('/requests', { params: { page, size } })
    .then(response => response.data);
}

/** Devuelve { status, data }: 202 disparada, 503 registrada sin credencial, 502 GitHub rechazo. */
export function createRequest(token, body) {
  return client(token)
    .post('/requests', body, {
      headers: { 'Content-Type': 'application/json' },
      validateStatus: status => [202, 502, 503].includes(status)
    })
    .then(response => ({ status: response.status, data: response.data }));
}

export function retryRequest(token, requestId) {
  return client(token)
    .post(`/requests/${encodeURIComponent(requestId)}/retry`, null, {
      validateStatus: status => [202, 502, 503].includes(status)
    })
    .then(response => ({ status: response.status, data: response.data }));
}

/** Prod (etapa 3): otra cuenta staff aprueba la solicitud y recien ahi se ejecuta. */
export function approveRequest(token, requestId) {
  return client(token)
    .post(`/requests/${encodeURIComponent(requestId)}/approve`, null, {
      validateStatus: status => [202, 502, 503].includes(status)
    })
    .then(response => ({ status: response.status, data: response.data }));
}

/** Prod (etapa 3): rechaza una solicitud pendiente; no se ejecuta nada. */
export function rejectRequest(token, requestId) {
  return client(token)
    .post(`/requests/${encodeURIComponent(requestId)}/reject`)
    .then(response => response.data);
}

/** Mensaje legible de un error del back ({ code, message }) o de red. */
export function errorMessage(error) {
  const data = error && error.response && error.response.data;
  if (data && data.message) {
    return data.message;
  }
  return 'No se pudo completar la operación. Probá de nuevo en unos minutos.';
}
